import React from 'react';
import PropTypes from 'prop-types';
import {
  renderLabel,
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import { getIconPath } from '@tcp/core/src/utils';
import { pdpSubLabels, PDP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/PDP.labels.js';
import withStyles from '../../../../../common/hoc/withStyles';
import storeSpecialPriceTagStyle from './StoreSpecialPriceTag.style'; // Assuming the file for styles is named PriceTag.css

const StoreSpecialPriceTag = ({
  offerPrice,
  className,
  isPickupSelectedAtProductDetail,
  storeSpecialPrice,
  fromQV,
  TCPPromotionPrice = '',
}) => {
  const pickupLabel = renderLabel(
    getLabelFromCopyOrFromTranslation(
      `${PDP_SUB_LABELS}.lbl_store_special_pickup_today`,
      pdpSubLabels
    ),
    'lbl_store_special_pickup_today'
  );

  const stsPriceLabel = renderLabel(
    getDynamicLabelValues('dynamic.browse_d.lbl_sth_or_sts_price'),
    'lbl_sth_or_sts_price'
  );
  const specialLabel = renderLabel(
    getLabelFromCopyOrFromTranslation(`${PDP_SUB_LABELS}.lbl_store_special_txt`, pdpSubLabels),
    'lbl_store_special_txt'
  );

  if (isPickupSelectedAtProductDetail) {
    return (
      <div className={`${className} price-tag-container`}>
        <div className={`price-display ${fromQV ? 'price-display-qv' : ''}`}>
          <span className="pickup-label">{stsPriceLabel}: </span>
          <span className="final-price">
            ${parseFloat(TCPPromotionPrice || offerPrice).toFixed(2)}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`${className} price-tag-container`}>
      <div className="special-label">
        <img src={getIconPath('store-special-pin')} alt="pickup-store" className="pickup-icon" />
        <span>{specialLabel}</span>
      </div>
      <div className={`price-display`}>
        <span className="pickup-label">{pickupLabel}: </span>
        <span className="final-price">
          $
          {storeSpecialPrice?.toString()?.includes('-')
            ? storeSpecialPrice
            : parseFloat(storeSpecialPrice).toFixed(2)}
        </span>
      </div>
    </div>
  );
};

StoreSpecialPriceTag.defaultProps = {
  offerPrice: 0,
  className: '',
  isPickupSelectedAtProductDetail: false,
  storeSpecialPrice: 0,
  fromQV: false,
};

StoreSpecialPriceTag.propTypes = {
  offerPrice: PropTypes.number,
  className: PropTypes.string,
  isPickupSelectedAtProductDetail: PropTypes.bool,
  storeSpecialPrice: PropTypes.number,
  fromQV: PropTypes.bool,
};

export default withStyles(StoreSpecialPriceTag, storeSpecialPriceTagStyle);
